/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './articlecontent.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/router';
import * as import3 from '@angular/common';
import * as import4 from '../../../../app/article/articlecontent/articlecontent.component';
import * as import5 from '../../../../app/shared/services/stringutils';
import * as import6 from '../../../../app/shared/type-builder/type.builder';
const styles_ArticleContentComponent:any[] = [import0.styles];
export const RenderType_ArticleContentComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_ArticleContentComponent,
  data: {}
}
);
export function View_ArticleContentComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(402653184,1,{contentContainer: 0}),
      (l()(),import1.ɵeld(0,(null as any),(null as any),30,'div',([] as any[]),[[
        8,
        'id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',[[
        'class',
        'hero-ramjet'
      ]
      ],[[
        1,
        'hero-id',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(16777216,[
      [
        1,
        3
      ]
      ,
      [
        'content',
        1
      ]

    ]
      ,(null as any),0,'div',[[
        'class',
        'content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'row author-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'col-4'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'author'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['by'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'a',[[
        'routerLink',
        '/about-us.html'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,16).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import2.RouterLinkWithHref,[
      import2.Router,
      import2.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'col'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'publish-date'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      ''
    ]
    )),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_5:any = '/about-us.html';
    ck(v,16,0,currVal_5);
  },(ck,v) => {
    var co:import4.ArticleContentComponent = v.component;
    const currVal_0:any = import1.ɵinlineInterpolate(1,'article_',((co.article == null)? (null as any): co.article.id),'');
    ck(v,1,0,currVal_0);
    const currVal_1:any = import1.ɵinlineInterpolate(1,'',((co.article == null)? (null as any): co.article.id),'');
    ck(v,3,0,currVal_1);
    const currVal_2:any = ((co.article == null)? (null as any): co.article.title);
    ck(v,4,0,currVal_2);
    const currVal_3:any = import1.ɵnov(v,16).target;
    const currVal_4:any = import1.ɵnov(v,16).href;
    ck(v,15,0,currVal_3,currVal_4);
    const currVal_6:any = ((co.article == null)? (null as any): co.article.author);
    ck(v,17,0,currVal_6);
    const currVal_7:any = ((co.article == null)? (null as any): co.article.readableDate);
    ck(v,23,0,currVal_7);
    const currVal_8:any = ((co.article == null)? (null as any): co.article.tag);
    ck(v,27,0,currVal_8);
  });
}
function View_ArticleContentComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'articlecontent',([] as any[]),(null as any),(null as any),(null as any),View_ArticleContentComponent_0,RenderType_ArticleContentComponent)),
    import1.ɵdid(4374528,(null as any),0,import4.ArticleContentComponent,[
      import5.StringUtils,
      import6.DynamicTypeBuilder,
      'isBrowser'
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const ArticleContentComponentNgFactory:import1.ComponentFactory<import4.ArticleContentComponent> = import1.ɵccf('articlecontent',import4.ArticleContentComponent,View_ArticleContentComponent_Host_0,{article: 'article'},{onVisible: 'onVisible'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/article/articlecontent/articlecontent.component.ngfactory.ts